import type { GitHost } from "./api";

/** Slug der vorbelegten mindcode-Git-Host-Zeile (Backend-Seed, #117-Follow-up). */
export const MINDCODE_HOST_ID = "mindcode";

/**
 * Liefert die mindcode-Zeile genau dann zurück, wenn sie existiert und noch
 * **kein** Forge-Token hat — dann zeigt die First-Run-Karte ihr Formular. Sobald
 * der Token gesetzt ist (`has_forge_token === true`) oder der Host fehlt,
 * liefert sie `null` (Karte verschwindet).
 */
export function findMindcodeNeedingToken(hosts: GitHost[]): GitHost | null {
  return hosts.find((h) => h.id === MINDCODE_HOST_ID && !h.has_forge_token) ?? null;
}
